import adminRequest from '@formosa/shared/api/adminRequest';
import { travelAdminJson } from '@formosa/shared/api/parseTravelAdminJson';
import { ADMIN_API } from '@formosa/shared/constants/endpoints';

/**
 * Travel Ads 管理後台 API 客戶端。
 * 掛載 travelAdminJson (parseTravelAdminJson) 確保 15 位以上大整數 Snowflake ID 維持精確字串型別。
 */
export const adsAdminApi = {
  // 1. 推廣申請審核
  promotionsReviewQueue: (params) =>
    adminRequest.get(`${ADMIN_API}/travel-manage/ads/promotions/review-queue`, { params, ...travelAdminJson }),

  beginPromotionReview: (id, data) =>
    adminRequest.post(`${ADMIN_API}/travel-manage/ads/promotions/${String(id)}/begin-review`, data, travelAdminJson),

  approvePromotion: (id, data) =>
    adminRequest.post(`${ADMIN_API}/travel-manage/ads/promotions/${String(id)}/approve`, data, travelAdminJson),

  rejectPromotion: (id, data) =>
    adminRequest.post(`${ADMIN_API}/travel-manage/ads/promotions/${String(id)}/reject`, data, travelAdminJson),

  // 2. 廣告素材審核
  creativesReviewQueue: (params) =>
    adminRequest.get(`${ADMIN_API}/travel-manage/ads/creatives/review-queue`, { params, ...travelAdminJson }),

  beginCreativeReview: (id, data) =>
    adminRequest.post(`${ADMIN_API}/travel-manage/ads/creatives/${String(id)}/begin-review`, data, travelAdminJson),

  approveCreative: (id, data) =>
    adminRequest.post(`${ADMIN_API}/travel-manage/ads/creatives/${String(id)}/approve`, data, travelAdminJson),

  rejectCreative: (id, data) =>
    adminRequest.post(`${ADMIN_API}/travel-manage/ads/creatives/${String(id)}/reject`, data, travelAdminJson),

  // 3. 廣告活動營運
  getCampaign: (id) =>
    adminRequest.get(`${ADMIN_API}/travel-manage/ads/campaigns/${String(id)}`, travelAdminJson),

  suspendCampaign: (id, data) =>
    adminRequest.post(`${ADMIN_API}/travel-manage/ads/campaigns/${String(id)}/suspend`, data, travelAdminJson),

  releaseCampaignSuspension: (id, data) =>
    adminRequest.post(`${ADMIN_API}/travel-manage/ads/campaigns/${String(id)}/release-suspension`, data, travelAdminJson),
};
